
import { Component, VModel, Prop, Watch } from 'vue-property-decorator'
import { Debounce } from 'vue-debounce-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import CompanyInfoMixin from '@/_mixins/companyInfo.mixin'
import { getRequest } from '@/plugins/api-axios'
import { deserialise } from 'kitsu-core'

@Component({
    mixins: [ObservationMixin, CompanyInfoMixin],
    inheritAttrs: false,
})
export default class RelatedCompaniesFilter extends Mixins<MixinInterface>(
    ObservationMixin,
    CompanyInfoMixin
) {
    @VModel({ required: true }) filter!: Array<string>
    @Prop({ default: 'relatedCompanies' }) kind!: string

    @Prop({ default: null, required: false }) project!: string | null
    @Prop({ default: null, required: false }) group!: string | null
    @Prop({ default: false }) hasIsNull!: boolean

    get label() {
        const translationKey = `observation_labels['observation.${this.kind}']`
        return this.$te(translationKey)
            ? this.$t(translationKey)
            : this.$t(`observation_fe['filter.${this.kind}.label']`)
    }

    // Search
    loading = false
    searchTerm = ''
    isDirty = false
    companies: Array<any> = []

    get items() {
        const specialItems = this.hasIsNull
            ? [
                  {
                      id: 'null',
                      name: this.$t(`observation_fe["filter.${this.kind}.onlyIsNull"]`),
                  },
              ]
            : []
        return [...specialItems, ...this.companies]
    }

    customCompaniesFilter(item, queryText) {
        const normalizedQuery = queryText.trim().toLowerCase()

        return (
            item.id == 'null' ||
            item.name.toLowerCase().includes(normalizedQuery) ||
            (item.orgNo && item.orgNo.replace(/\s+/g, '').toLowerCase().includes(normalizedQuery))
        )
    }

    async onItemClick(id: string) {
        await this.$nextTick()
        if (this.filter.includes('null') && this.filter.length > 1) {
            this.filter = id === 'null' ? ['null'] : this.filter.filter((item) => item !== 'null')
        }
    }

    @Watch('searchTerm')
    @Watch('isDirty')
    inishLoading() {
        if (!this.isDirty) return
        this.loading = true
    }

    @Watch('searchTerm')
    @Watch('isDirty')
    @Debounce(500)
    async getRelatedCompanies() {
        if (!this.isDirty) return
        this.loading = true

        let params = {
            ...(this.group && { 'filter[suggestedRelatedCompanyForProjectGroup]': this.group }),
            ...(this.project && { 'filter[suggestedRelatedCompanyForProject]': this.project }),
            ...(this.searchTerm &&
                this.searchTerm.length > 1 && { 'filter[searchTerm]': this.searchTerm }),
            'page[limit]': 10,
        }

        const { data } = await getRequest(
            this.getURL({
                path: `companies`,
                base: process.env.VUE_APP_OBSERVATIONS_BASE_URL,
                params: {
                    include: '',
                    skipLinks: '',
                    ...params,
                },
            })
        )

        if (data) this.companies = deserialise(data).data

        this.loading = false
    }

    async searchSelectedCompanies() {
        if (!this.filter || this.filter.includes('null') || this.filter.length === 0) return

        const { data } = await getRequest(
            this.getURL({
                path: `companies`,
                base: process.env.VUE_APP_COMPANY_BASE_URL,
                params: {
                    include: '',
                    skipLinks: '',
                    'filter[id]': this.filter.join(','),
                },
            })
        )

        if (data) this.companies = deserialise(data).data
    }

    async mounted() {
        this.loading = true

        try {
            this.searchSelectedCompanies()
        } finally {
            this.loading = false
        }
    }
}
